import NextImage from '@allesauto/core/nextImage';
import A from '@allesauto/design/img/A.png';
import AA from '@allesauto/design/img/AA.png';
import AB from '@allesauto/design/img/AB.png';
import AC from '@allesauto/design/img/AC.png';
import AD from '@allesauto/design/img/AD.png';
import AE from '@allesauto/design/img/AE.png';
import AF from '@allesauto/design/img/AF.png';
import AG from '@allesauto/design/img/AG.png';
import B from '@allesauto/design/img/B.png';
import BB from '@allesauto/design/img/BB.png';
import BC from '@allesauto/design/img/BC.png';
import BD from '@allesauto/design/img/BD.png';
import BE from '@allesauto/design/img/BE.png';
import BF from '@allesauto/design/img/BF.png';
import BG from '@allesauto/design/img/BG.png';
import C from '@allesauto/design/img/C.png';
import CC from '@allesauto/design/img/CC.png';
import CD from '@allesauto/design/img/CD.png';
import CE from '@allesauto/design/img/CE.png';
import CF from '@allesauto/design/img/CF.png';
import CG from '@allesauto/design/img/CG.png';
import D from '@allesauto/design/img/D.png';
import DD from '@allesauto/design/img/DD.png';
import DE from '@allesauto/design/img/DE.png';
import DF from '@allesauto/design/img/DF.png';
import DG from '@allesauto/design/img/DG.png';
import E from '@allesauto/design/img/E.png';
import EE from '@allesauto/design/img/EE.png';
import EF from '@allesauto/design/img/EF.png';
import EG from '@allesauto/design/img/EG.png';
import F from '@allesauto/design/img/F.png';
import FF from '@allesauto/design/img/FF.png';
import FG from '@allesauto/design/img/FG.png';
import G from '@allesauto/design/img/G.png';
import GG from '@allesauto/design/img/GG.png';
import React, { FC } from 'react';

export type EfficiencyType = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

type EfficiencyCombinedKey =
  | 'A-A'
  | 'A-B'
  | 'A-C'
  | 'A-D'
  | 'A-E'
  | 'A-F'
  | 'A-G'
  | 'B-B'
  | 'B-C'
  | 'B-D'
  | 'B-E'
  | 'B-F'
  | 'B-G'
  | 'C-C'
  | 'C-D'
  | 'C-E'
  | 'C-F'
  | 'C-G'
  | 'D-D'
  | 'D-E'
  | 'D-F'
  | 'D-G'
  | 'E-E'
  | 'E-F'
  | 'E-G'
  | 'F-F'
  | 'F-G'
  | 'G-G';

const efficiencyIcons = {
  A: A,
  B: B,
  C: C,
  D: D,
  E: E,
  F: F,
  G: G,
};

const efficiencyIconsDischargedBatteryWltp = {
  ['A-A']: AA,
  ['A-B']: AB,
  ['A-C']: AC,
  ['A-D']: AD,
  ['A-E']: AE,
  ['A-F']: AF,
  ['A-G']: AG,
  ['B-B']: BB,
  ['B-C']: BC,
  ['B-D']: BD,
  ['B-E']: BE,
  ['B-F']: BF,
  ['B-G']: BG,
  ['C-C']: CC,
  ['C-D']: CD,
  ['C-E']: CE,
  ['C-F']: CF,
  ['C-G']: CG,
  ['D-D']: DD,
  ['D-E']: DE,
  ['D-F']: DF,
  ['D-G']: DG,
  ['E-E']: EE,
  ['E-F']: EF,
  ['E-G']: EG,
  ['F-F']: FF,
  ['F-G']: FG,
  ['G-G']: GG,
};

interface EfficiencyIconProps {
  efficiencyCo2Class?: EfficiencyType;
  co2ClassDischargedBatteryWltp?: EfficiencyType;
}

const EfficiencyIcon: FC<React.PropsWithChildren<EfficiencyIconProps>> = ({
  efficiencyCo2Class,
  co2ClassDischargedBatteryWltp,
}) => {
  let iconSrc;
  if (efficiencyCo2Class && co2ClassDischargedBatteryWltp) {
    const combinedKey =
      `${efficiencyCo2Class}-${co2ClassDischargedBatteryWltp}` as EfficiencyCombinedKey;
    iconSrc = efficiencyIconsDischargedBatteryWltp[combinedKey];
  } else {
    iconSrc = efficiencyCo2Class && efficiencyIcons[efficiencyCo2Class];
  }

  return (
    <>
      {iconSrc && (
        <NextImage
          src={iconSrc}
          alt="Efficiency Icon"
          width={400}
          height={400}
          objectFit="cover"
          unoptimized
        />
      )}
    </>
  );
};

export default EfficiencyIcon;
